import React from 'react'
import { MdNavigateBefore, MdNavigateNext } from 'react-icons/md'
import { useStateContext } from '../contexts/ContextProvider';

const Pagination = ({prev, next}) => {
      const { currentColor } = useStateContext();
    console.log('currentColor', currentColor)
  return (
    <div class="flex">
    <button onClick={prev} className={`border border-${currentColor} text-blue-500  rounded-sm font-bold py-4 px-6 mr-2 flex items-center hover:bg-blue-500 hover:text-white`}
    style={{ borderColor: currentColor,
             color: currentColor,
     }}
    >
      
        Précédent 
        <MdNavigateBefore />
    </button>
    <button onClick={next} class="border border-blue-500 bg-blue-500 text-white  rounded-sm font-bold py-4 px-6 ml-2 flex items-center"
      style={{ borderColor: currentColor,
        backgroundColor: currentColor,
}}
    >
        Suivant
        <MdNavigateNext />
    </button>
</div>
  )
}

export default Pagination
